import * as React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';

export const ElearningPrompt: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="subtitle1" align="center">
          {t('user:profile.thanksForRegistering', 'Thank you for registering.')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" align="center">
          <Button variant="contained" color="secondary" href="/eLearning">
            {t('user:profile.proceedToMyCourses', 'Proceed to My Courses')}
          </Button>
        </Typography>
      </Grid>
    </>
  );
};
